
import Vue from 'vue';
import Ad from '@/store/modules/ads/ad';
import { formatNumber } from '@/i18n';
import AdClickUsersModal from '@/components/layout/ad-click-users-modal.vue';

export default Vue.extend({
  name: 'AdClickStats',
  props: {
    ad: { type: Ad, required: true },
    summary: { type: Boolean, default: false },
  },
  methods: {
    formatNumber,
    showDetails() {
      this.$modal.show(AdClickUsersModal, { ad: this.ad }, { name: 'ad-click-users' });
    },
  },
});
